{
  "overridesEnabledBadgeLabel": "재정의 켜기",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "개발",
  "releaseBadgePoc": "POC"
}
